export { default } from './leasing-card-mobile';
